import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Form, Formik } from 'formik';

import { Input } from '@/common';
import { Button } from '@/components/generic';
import { ButtonVariant } from '@/components/generic/Button/button-config';
import { queryClient } from '@/configuration/react-query';
import { PUBLIC_PAGE_ROUTES } from '@/enums';
import { showToast, ToastType } from '@/helpers/toast';
import { DetailsPagePassword } from '@/pages/SetPassword/DetailsPage';
import { forgotPasswordSchema } from '@/pages/SetPassword/EmailValidation';
import { LeftChevronBlackIcon as ArrowLeftIcon, SentoaLogo } from '@/resources';
import { useForgotPasswordMutation } from '@/services';
import { ForgotPasswordCredentials } from '@/types';

export const SendEmail = () => {
  const navigate = useNavigate();
  const [t] = useTranslation('common');

  const { mutate: forgotPassword } = useForgotPasswordMutation(queryClient, {
    onSuccess: () => {
      showToast(ToastType.SUCCESS, t('passwordResetEmail'));
      navigate(PUBLIC_PAGE_ROUTES.CHECK_EMAIL);
    },
    onError: () => {
      showToast(ToastType.ERROR, t('passwordResetEmailError'));
    }
  });

  const initialValues: ForgotPasswordCredentials = {
    email: ''
  };

  const handleSubmit = async (values: ForgotPasswordCredentials) => {
    forgotPassword(values);
  };

  return (
    <DetailsPagePassword>
      <div className='z-[100] w-[90%] rounded-3xl bg-primary-white p-6 sm:w-auto'>
        <div className='flex h-80 w-full flex-col justify-start gap-6 sm:w-96'>
          <div className='flex w-full justify-center'>
            <SentoaLogo className='h-10 w-44' />
          </div>
          <div className='flex justify-center'>
            <div className='h-px w-full bg-blue-powder' />
          </div>
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={forgotPasswordSchema}>
            {({ errors, touched }) => (
              <Form className='flex flex-col gap-y-6'>
                <Input
                  id='email'
                  type='text'
                  label={t('email')}
                  errorMessage={errors.email}
                  isInvalid={!!errors.email && touched.email}
                />
                <Button variant={ButtonVariant.PRIMARY} type='submit' className='mb-0 w-full'>
                  {t('send')}
                </Button>
              </Form>
            )}
          </Formik>
          <div className='mt-0 flex justify-center'>
            <Button
              variant={ButtonVariant.TERTIARY}
              handleOnClick={() => navigate(PUBLIC_PAGE_ROUTES.LOGIN)}
              className='border-0'>
              <ArrowLeftIcon className='mr-2 text-base' />
              {t('backToLogin')}
            </Button>
          </div>
        </div>
      </div>
    </DetailsPagePassword>
  );
};
